<template>
    <div class="content-wrapper">
        <div class="main-content">
            <student-register />
        </div>
    </div>
</template>

<script>
import StudentRegister from "@/components/UserLogin/StudentRegister.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
export default {
    components: {
        StudentRegister,
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
    },
    methods: {
        updateHeadMeta() {
            const title =
                this.currentLanguage === "ar"
                    ? "التسجيل - Planning Force | انضم إلى منصة التدريب لدينا"
                    : "Sign Up - Planning Force | Join Our Training Platform";

            const description =
                this.currentLanguage === "ar"
                    ? "سجل الآن للانضمام إلى منصة Planning Force التدريبية وابدأ رحلتك في تعلم المهارات الحديثة."
                    : "Sign up now to join the Planning Force training platform and start your journey in learning modern skills.";

            const keywords =
                this.currentLanguage === "ar"
                    ? "التسجيل, تعلم مهارات, منصة تدريب, Planning Force, الانضمام"
                    : "sign up, learning skills, training platform, Planning Force, join";

            useHead({
                title: title,
                meta: [
                    { name: "description", content: description },
                    { name: "keywords", content: keywords },
                    { name: "robots", content: "index, follow" },
                    {
                        name: "author",
                        content:
                            this.currentLanguage === "ar"
                                ? "معهد Planning Force العالي للتدريب"
                                : "Planning Force High Institute for Training",
                    },
                    {
                        name: "language",
                        content: this.currentLanguage === "ar" ? "ar" : "en",
                    },

                    // Open Graph meta tags
                    { property: "og:title", content: title },
                    { property: "og:description", content: description },
                    {
                        property: "og:image",
                        content: "https://example.com/signup-og-image.jpg", // Replace with your sign-up page image URL
                    },
                    { property: "og:url", content: "https://example.com/signup" }, // Replace with your sign-up page URL
                    { property: "og:type", content: "website" },

                    // Twitter Card meta tags
                    { name: "twitter:card", content: "summary_large_image" },
                    { name: "twitter:title", content: title },
                    { name: "twitter:description", content: description },
                    {
                        name: "twitter:image",
                        content: "https://example.com/signup-twitter-image.jpg", // Replace with your sign-up page image URL
                    },
                ],
            });
        }

    },
    mounted() {
        this.updateHeadMeta();
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                //  this.language = newLang;
                this.updateHeadMeta();
            },
            immediate: true, // Run the handler immediately when the component is mounted
        },
    },
};
</script>
